var modules_3734c084 = {"wrapper":"_vmwg77","wrapper--hidden":"_19zouzx","overlay":"_1ssderw","header":"_6gdnb3"};
import "../../../assets/BLrsuvAe.css";

export { modules_3734c084 as default };
//# sourceMappingURL=fullscreen-wrapper.module.scss.js.map
